import CryptoJS from 'crypto-js'

const LOGIN_AES_KEY = CryptoJS.enc.Utf8.parse('n8Kp2WmQvX4rT9hL')
const LOGIN_AES_IV = CryptoJS.enc.Utf8.parse('sJ6fYc1BnH7uAe0D')

/**
 * 将登录密码按后端约定加密为 Base64 密文。
 */
export function encryptLoginPassword(password) {
  return CryptoJS.AES.encrypt(password, LOGIN_AES_KEY, {
    iv: LOGIN_AES_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}



// WEBPACK FOOTER //
// ./src/util/password.js